import { Body1 } from '@fluentui/react-components';
import { CalendarRegular } from '@fluentui/react-icons';
import { Avatar, useUsers } from '@modules/users';

import { formatReviewDate } from '../../helpers';
import { TFindingState } from '../../types';

export const FindingAssignment = ({ finding }: { finding: TFindingState }) => {
  const { users } = useUsers();
  const assignee = users?.find((user) =>
    finding.assigneeId
      ? user._id === finding.assigneeId
      : user.name === finding.assignee || user.mail === finding.assignee
  );

  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-3">
      {finding.assignee ? (
        <div className="flex items-center gap-2">
          <Avatar user={assignee} name={finding.assignee} size={28} tooltip={assignee ? 'mail' : 'none'} />
          <Body1>{assignee?.name || finding.assignee}</Body1>
        </div>
      ) : null}
      {finding.dueDate ? (
        <div className="flex items-center gap-2 text-neutralFg-3">
          <CalendarRegular className="text-lg" />
          <Body1>Due {formatReviewDate(finding.dueDate)}</Body1>
        </div>
      ) : null}
    </div>
  );
};
